var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetailedView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 27.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 7.49,
    height: 7.49,
    rx: 1.06,
    ry: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.99,
    width: 20.01,
    height: 7.49,
    rx: 1.14,
    ry: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 10.02,
    width: 7.49,
    height: 7.49,
    rx: 1.06,
    ry: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.99,
    y: 10.02,
    width: 20.01,
    height: 7.49,
    rx: 1.14,
    ry: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 20.05,
    width: 7.49,
    height: 7.49,
    rx: 1.06,
    ry: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.99,
    y: 20.05,
    width: 20.01,
    height: 7.49,
    rx: 1.14,
    ry: 1.14
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedView);
export default __webpack_public_path__ + "static/media/detailed-view.f37401605607a92c8137d8e2ae811a72.svg";
export { ForwardRef as ReactComponent };